// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../setDayOfYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var setDayOfYear = convertToFP(fn, 2);
export default setDayOfYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/setDayOfYear/index.js
// module id = 970
// module chunks = 0